import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Telemetry from '@atlassian/mpac-telemetry';
import { LABEL_CAAS_SPI_METHOD_EXECUTION } from '../telemetry/events';
import { instrumentAsync } from '../utils/instrumentation-utils';
let InternalSPI;
function instrumentFn(methodName, successful, duration) {
  Telemetry.task({
    task: LABEL_CAAS_SPI_METHOD_EXECUTION,
    taskId: methodName,
    successful,
    duration
  });
}
function wrapObjectOfFunctions(stringToFunctionMap) {
  return Object.keys(stringToFunctionMap).reduce((acc, k) => _objectSpread(_objectSpread({}, acc), {}, {
    [k]: instrumentAsync(stringToFunctionMap[k], instrumentFn, k)
  }), {});
}
function wrapIfPresent(stringToFunctionMap) {
  if (stringToFunctionMap) {
    return wrapObjectOfFunctions(stringToFunctionMap);
  } else {
    throw new Error('Unable to find SPI.');
  }
}
// unMountInitSPI() only to be used in storybooks
export function unMountInitSPI() {
  InternalSPI = undefined;
}
export function initSPI(spi) {
  if (InternalSPI) {
    return InternalSPI;
  }
  InternalSPI = wrapIfPresent(spi);
  // For use in pollinator tests
  window.__EMCEE__SPI__ = InternalSPI;
  return InternalSPI;
}
const getSPI = () => {
  if (InternalSPI) {
    return InternalSPI;
  } else {
    throw new Error('getSPI called before the SPI initializing the SPI using initSPI');
  }
};
export default getSPI;